import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { isUndefined } from 'util';
import { RestApiService } from "../shared/restApiServices/restapi.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css']
})
export class ChangePasswordDialogComponent implements OnInit {

  notSupportedSize : boolean;
  emailAddress:string = '';
  password = '';
  confirmpassword = '';
  passwordEmpty:string = '';
  verificationCode = '';
  codeEmpty:string = '';
  errMsg:string ='';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<ChangePasswordDialogComponent>, private restApiService: RestApiService) { 
    if (window.screen.width < 900) {
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }
  }

  ngOnInit() {
    this.emailAddress = this.data['email'];
  }

  cancel(){
    this.dialogRef.close(false);
  }

  confirmChangePassword(){

    this.passwordEmpty = '';
    this.codeEmpty = '';
    this.errMsg = '';

    if(this.verificationCode == null || isUndefined(this.verificationCode) || this.verificationCode=="")
    {
      this.codeEmpty = "on-error";
      return;
    }
    else if(this.password==null || isUndefined(this.password) || this.password=="" || this.password !== this.confirmpassword)
    {
      this.passwordEmpty = "on-error";
      return;
    }
    else {
      this.passwordEmpty = "";
      this.codeEmpty = '';

      this.restApiService.changePasswordOfUser(this.verificationCode,this.password).subscribe(
        result => {
          if (result.success) {
            this.dialogRef.close(true)
            // this.isShowLoader = false;
            // this.router.navigate(['/logIn'],{ queryParams: { email: this.userName} })
          }
          else {
            this.errMsg = result['value'];
            // this.isShowLoader = false;
            // this.signUpFailMsg ='Password reset failed';
            // this.signUpFail = true;
          }
        })
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
    // event.target.innerWidth;

  }

}



// WEBPACK FOOTER //
// ./src/app/change-password-dialog/change-password-dialog.component.ts